export default __webpack_public_path__ + "static/media/Bandit's Straps of World's Edge.f133ce11.jpg";